import React from 'react';
import {Flex, Title} from '@priority-software/priority-style-react';
import styles from './styles.module.scss';
import texts from '../texts';
import {ReactComponent as EmptyStateImage} from '../resources/empty-state-part-modal.svg';

export const EmptyState = () => {
    return (
        <Flex direction="column" componentClasses={styles.emptyStateContainer}>
            <EmptyStateImage />
            <Title
                skin="h2"
                componentClasses={styles.emptyStateText}
                text={texts.partsEmptyState}
            />
        </Flex>
    );
};
